// removed by extract-text-webpack-plugin
module.exports = {"card":"CentricUI__BuilderCard__BuilderCardLoader__card","empty":"CentricUI__BuilderCard__BuilderCardLoader__empty","wrapper":"CentricUI__BuilderCard__BuilderCardLoader__wrapper","loading":"CentricUI__BuilderCard__BuilderCardLoader__loading"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/product/productCard/components/BuilderCard/BuilderCardLoader.css
// module id = 1595
// module chunks = 10